import type { AllReporterVariant } from '../../RichTextEditor/hooks/useReporter';

import { Spacings } from 'styles';

import { Stack } from 'common/ui/Layout';
import useStudyIds from 'hooks/useStudyIds';
import { telemetryContextFor } from 'modules/Apollo/types';
import { useState } from 'react';
import { EditorWrapperElementProvider } from './EditorWrapperElementContext';

export const FIELDS_WRAPPER_PADDING = 32;
export const FIELDS_WRAPPER_TOP_PADDING = 16;

export type EditorWrapperProps = {
  variant: AllReporterVariant;
  children: React.ReactNode;
  isFieldPane?: boolean;
  space?: keyof typeof Spacings;
};

export const EditorWrapper = ({
  variant,
  children,
  isFieldPane = false,
  space = 'small',
}: EditorWrapperProps): React.ReactElement => {
  const studyIDs = useStudyIds({ context: APOLLO_QUERY_CONTEXT });
  const [editorWrapperElement, setEditorWrapperElement] = useState<HTMLElement | null>(null);

  let padding = isFieldPane ? 0 : FIELDS_WRAPPER_PADDING;
  let topPadding = 0;

  if (studyIDs.length > 0 && variant === 'report') {
    topPadding = 16;
  } else if (variant === 'report') {
    topPadding = FIELDS_WRAPPER_TOP_PADDING;
  } else {
    topPadding = padding = 0;
  }

  return (
    <EditorWrapperElementProvider value={editorWrapperElement}>
      {/* Capture the wrapper node so gutter affordances can anchor to it explicitly. */}
      <Stack
        ref={setEditorWrapperElement}
        vertical={variant === 'report'}
        css={`
          box-sizing: border-box;
          padding: ${topPadding}px ${padding}px ${padding}px ${padding}px;
          height: 100%;
          overflow: auto;
        `}
        stretchX
        stretchY
        data-testid={`fields-wrapper-${variant}`}
        space={space}
        data-stack-stretch
      >
        <>{children}</>
      </Stack>
    </EditorWrapperElementProvider>
  );
};

EditorWrapper.displayName = 'EditorWrapper';

const APOLLO_QUERY_CONTEXT = telemetryContextFor(EditorWrapper);
